import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { img } from '../../helpers';
import { ScCopyButton, ScPromoCodeField, ScPromoCodeRow } from './styled';

const COPIED_FEEDBACK_MS = 1500;

interface IPromoCodeFieldProps {
  code: string;
}

export const PromoCodeField = ({ code }: IPromoCodeFieldProps) => {
  const { t } = useTranslation('common');
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (!isCopied) return;
    const timer = setTimeout(() => setIsCopied(false), COPIED_FEEDBACK_MS);
    return () => clearTimeout(timer);
  }, [isCopied]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setIsCopied(true);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ScPromoCodeRow>
      <ScPromoCodeField className="notranslate" translate="no">
        {code}
      </ScPromoCodeField>
      <ScCopyButton
        $isCopied={isCopied}
        aria-label={t('copyCode.copyText')}
        data-copied={t('copyCode.access')}
        onClick={handleCopy}
        type="button"
      >
        <ImageComponent
          alt=""
          height={20}
          src={img('icon-copy.webp')}
          width={20}
        />
      </ScCopyButton>
    </ScPromoCodeRow>
  );
};
